module.exports = __webpack_public_path__ + "static/img/6areaB_10.c9ec444.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/6areaB_10.png
// module id = 1212
// module chunks = 1